module.exports = __webpack_public_path__ + "powered_by_geopagos.png?b85f97";


//////////////////
// WEBPACK FOOTER
// ./client/assets/powered_by_geopagos.png
// module id = 265
// module chunks = 0